<template>
  <div class="boardComponent">
    <b-card no-body>
      <b-card-header class="d-flex align-items-center">
        <div class="mr-3">Board</div>
        <b-input
          class="inputText"
          :value="input"
          :disabled="!this.isEditable"
          @update="inputManuallyUpdated"
        />
      </b-card-header>
      <b-card-body>
        <div class="cards">
          <div class="playingCard" v-for="card in cards" :key="card">
            <Card :cardString="card" :height="80" />
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  additionalCharactersAfterStringToCards,
  cardsToString,
  stringToCards,
} from "../helpers/cards";
import Card from "./Card";

export default {
  name: "Board",
  components: { Card },
  data() {
    return {
      input: "",
    };
  },
  props: {
    // v-model value: card strings
    value: { type: Array, default: () => [] },
    fixedCards: { type: Number, default: 0 },
    isEditable: { type: Boolean, default: true },
  },
  computed: {
    cards() {
      return this.value.slice(0, 5);
    },
  },
  methods: {
    async inputManuallyUpdated(value) {
      this.input = value;
      await this.$nextTick();
      const inputCards = stringToCards(value);
      // If the board contains at least the amount of fixed cards, then trying to delete a card
      // should result in the input being regenerated from the board. Also if the board just isn't editable.
      if (
        !this.isEditable ||
        (this.cards.length >= this.fixedCards && inputCards.length < this.fixedCards)
      ) {
        this.input = cardsToString(this.value);
        return;
      }
      this.$emit("input", inputCards);
    },
    updateInputFromBoard() {
      // Characters that are not represented on the board yet. If we were to immediately set the input
      // to whatever is on the board, user could never enter a full card consisting of two characters
      const additionalInput = additionalCharactersAfterStringToCards(this.input);
      this.input = cardsToString(this.value) + additionalInput;
    },
  },
  created() {
    this.updateInputFromBoard();
  },
  watch: {
    value(value) {
      this.updateInputFromBoard();
    },
  },
};
</script>

<style lang="scss" scoped>
.cards {
  display: flex;
}
.playingCard {
  margin-right: 8px;
}
.inputText {
  height: 1.7em;
  padding-top: 0.1em;
  padding-bottom: 0.1em;
}
</style>
